<template>
    <section class="tab-pane" :id="keyWordIndex">

        <div class="form-group">
            <label class="col-form-label">Filter <q>{{ itemName }}(s)</q></label>
            <input class="form-control border border-dark" type="text" v-model.trim="itemQuery" />
        </div>

        <div class="form-group">
            <label class="col-form-label">Select <q>{{ itemName }}{{ (preSelected === null) ? '(s)' : '' }}</q></label>
            <select class="form-control border border-dark" v-model="selectedItem" size="8" :multiple="preSelected === null" >
                <option v-for="item of filteredItems" :value="item">{{ item.name }}</option>
            </select>
        </div>

    </section>
</template>

<script>
export default{
    props : {

        items : {
            type : Array,
            required : true
        },

        keyWordIndex : {
            type : String,
            required : true
        },

        preSelected : {
            type : Object,
            default : null
        },

    },

    
    data(){
        return {
            selectedItem : [],
            itemQuery : ""
        };
    },

    mounted(){
        let something = (this.preSelected != null) ? this.preSelected : {entity_id : 0, entity_type : ""};

        this.findPreSelectedItem(something);
    },

    computed : {

        filteredItems(){
            if (this.itemQuery.length){
                return this.items.filter((item) => { return item.name.toLowerCase().includes(this.itemQuery.toLowerCase()); });
            }
            return this.items;
        },

        itemName(){
            if (this.items.length > 0) return this.items[0].type.name;
            return "";
        }

    },

    watch : {

        selectedItem(){
            this.$emit("gpeUpdate", this.selectedItem);
        }

    },

    methods : {

        findPreSelectedItem(entityObject){
            let tempArray = this.items.filter((item) => { return (item.id === entityObject.entity_id && item.model === entityObject.entity_type); });
            if (tempArray.length > 0) this.selectedItem = tempArray[0];
        },

        clearSelectedItems(){
            this.selectedItem.splice(0);
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/data-set/TabSectionWithFilterAndSelect.vue